// import { useI18n } from 'vue-i18n';

/* eslint-disable no-param-reassign */
export default {
    install: function install(app, i18n, store) {
        app.$i18n = i18n;
        app.$store = store;
        // i18n exposes an install function via createI18n
        i18n.install(app);

        // NU_TODO: https://urbnit.atlassian.net/browse/TYP-34445
        // Remove this migration workaround when we are fully migrated to the composition API
        const composer = i18n.global;
        // wire the old-style helpers straight to it
        app.config.globalProperties.$t = composer.t.bind(composer);
        app.config.globalProperties.$d = composer.d.bind(composer);
        app.config.globalProperties.$tc = composer.t.bind(composer); // plural alias

        // NU_TODO: https://urbnit.atlassian.net/browse/TYP-34514
        // Remove this migration workaround when move to vite, and are using @intlify/unplugin-vue-i18n
        // cache to skip duplicate merges
        const seen = new WeakSet();
        // merge the i18n blocks into the i18n instance
        // we need to do this because vue-i18n-loader doesnt do this when using full composition API mode
        app.mixin({
            beforeCreate() {
                // eslint-disable-next-line no-underscore-dangle
                const blocks = this.$options?.__i18n;
                if (blocks && !seen.has(this.$options)) {
                    const locale = i18n.global.locale.value;

                    blocks.forEach((block) => {
                        if (block?.resource[locale]) {
                            i18n.global.mergeLocaleMessage(locale, block?.resource[locale]);
                        }
                    });
                    seen.add(this.$options);
                }
            },
        });
    },
};
